<!--
 * @Descripttion: 
 * @version: 
 * @Author: geory
 * @Date: 2023-08-14 17:08:47
 * @LastEditors: geory
 * @LastEditTime: 2025-05-07 10:57:51
-->
<template>
  <div id="app">
    <menubar v-if="!$route.meta.hideTopBar" />
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <VoiceGuide />
  </div>
</template>

<script>
import menubar from "@/components/menubar";
import VoiceGuide from "@/components/VoiceGuide";

// 与 router.js 保持同步的非主窗口路由列表
const NON_GUIDE_ROUTES = [
  "/authGuide", "/setting", "/autoSend",
  "/huashuEdit", "/huashuImport", "/imageList", "/huashuReview", "/memoEdit",
];
const GUIDE_ROUTES = ["/home", "/whome"];
const GUIDE_PENDING_KEY = "wminput:voice-guide-pending";
const GUIDE_STEP_KEY = "wminput:voice-guide-step";

export default {
  name: "App",
  data() {
    return {
      guideCheckPending: false,
      guideCheckCompleted: false,
    };
  },
  created() {
    // 到达主窗口路由时触发引导检查，离开主窗口时隐藏
    this.$watch("$route", function (toRoute) {
      if (this.$store.state.guideVisible && NON_GUIDE_ROUTES.includes(toRoute.path)) {
        this.$store.commit("hideGuide");
      }
      if (GUIDE_ROUTES.includes(toRoute.path)) {
        this.restoreGuideIfNeeded();
      }
      if (!this.guideCheckCompleted && GUIDE_ROUTES.includes(toRoute.path)) {
        this.checkVoiceGuide();
      }
    });
    // 初始路由已是主窗口路由（刷新页面等场景）
    if (GUIDE_ROUTES.includes(this.$route.path)) {
      this.restoreGuideIfNeeded();
      this.checkVoiceGuide();
    }
  },
  mounted() {},
  components: {
    menubar,
    VoiceGuide,
  },
  methods: {
    hasLogin() {
      return Boolean(
        this.$store.state.token || localStorage.getItem("edujia:group:web:token")
      );
    },
    restoreGuideIfNeeded() {
      try {
        if (!this.hasLogin()) return;
        if (sessionStorage.getItem(GUIDE_PENDING_KEY) !== "1") return;
        if (this.$store.state.guideVisible) return;
        this.$store.commit("showGuide");
        const step = Number(sessionStorage.getItem(GUIDE_STEP_KEY) || "1");
        if (step === 2) {
          this.$store.commit("setGuideStep", 2);
        }
      } catch (_) {}
    },
    checkVoiceGuide() {
      if (this.guideCheckCompleted || this.guideCheckPending) return;
      if (!this.hasLogin()) return;

      // ── 硬信号：主进程通过真实查询参数（window.location.search）标记的子窗口 ──
      if (window.location.search.includes("_noGuide=1")) {
        this.guideCheckCompleted = true;
        return;
      }

      // ── 路径判断：优先用 Vue Router 解析的路径，兜底用 location.hash ──
      const routePath = this.$route && this.$route.path;
      const hashPath = window.location.hash.replace("#", "").split("?")[0] || "";
      const currentPath = routePath || hashPath;

      if (!currentPath) return;
      if (NON_GUIDE_ROUTES.includes(currentPath)) return;
      if (!GUIDE_ROUTES.includes(currentPath)) return;

      try {
        if (window.require) {
          const { ipcRenderer } = window.require("electron");
          this.guideCheckPending = true;
          ipcRenderer.invoke("voice-guide-check").then((needGuide) => {
            this.guideCheckPending = false;
            this.guideCheckCompleted = true;
            if (!needGuide) return;
            const finalPath = this.$route && this.$route.path;
            if (
              finalPath &&
              !NON_GUIDE_ROUTES.includes(finalPath) &&
              GUIDE_ROUTES.includes(finalPath)
            ) {
              try {
                sessionStorage.setItem(GUIDE_PENDING_KEY, "1");
                sessionStorage.setItem(GUIDE_STEP_KEY, "1");
              } catch (_) {}
              this.$store.commit("showGuide");
            }
          }).catch(() => {
            this.guideCheckPending = false;
          });
        }
      } catch (_) {}
    },
  },
};
</script>

<style type="text/css">
@import "common/css/common.css";
</style>
